"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessTypes = void 0;
var BusinessTypes;
(function (BusinessTypes) {
    BusinessTypes["PRODUCT_SALES"] = "product_sales";
    BusinessTypes["CONSULTING"] = "consulting";
    BusinessTypes["TRAVEL"] = "travel";
    BusinessTypes["DIGITAL_SALES"] = "digital_sales";
    BusinessTypes["AESTHETIC_SALON"] = "aesthetic_salon";
    BusinessTypes["OTHER"] = "other";
})(BusinessTypes = exports.BusinessTypes || (exports.BusinessTypes = {}));
//# sourceMappingURL=Corporation.js.map